import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import ErrorHandler from "../../components/error-handler/component";
import {dataRegister} from "../../services/dataRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class NoPage extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/no-page');
            ReactGA4.send({ hitType: "pageview", page: "/no-page" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }
    }

    _renderText(item) {
        return langRegister.get("no-page", item, "en");
    }

    render() {
        return (
            <div className={Styles.container}>
                <ErrorHandler/>
            </div>
        );
    }
}

export default NoPage;


// WEBPACK FOOTER //
// ./src/pages/no-page/component.js